<template>
	<div v-if="hasPermission">
		<ContentLedgerAccounts />
	</div>
</template>

<script>
// @ is an alias to /src

// import Loans from '@/components/content/content-loans/ContentLoans.vue'
import ContentLedgerAccounts from '@/components/content/content-acc/ContentLedgerAccounts.vue'
import { getPermissions } from '../components/util/liblist'

export default {
	name: 'LedgerAccounts',
	components: {
		ContentLedgerAccounts,
	},
	data() {
		return {
			'hasPermission': false, 
		}
	},
	mounted() {
		if (getPermissions('accounting.report.ledger')) {
			this.hasPermission = true
		}
	},
	computed: {

	},
	methods: {

	},
}
</script>
